import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Descriptions } from "antd";
import { useTranslation } from "react-i18next";

import {
  selectYear,
  selectMonth,
  selectDay,
  selectCategory,
  selectShipType,
} from "@/selector";
import {
  getDefaultYear,
  getDefaultMonth,
  getDefaultDay,
  promiseDispatch,
} from "@/util";
import { actionCreators } from "@/duck/dashboard";
import "@/components/dashboard/indicator/LayerIndicator.less";

const LayerIndicator = () => {
  const { t, i18n } = useTranslation();
  const [startPoint, setStartPoint] = useState();
  const [endPoint, setEndPoint] = useState();
  const dispatch = useDispatch();
  const category = useSelector(selectCategory);
  const year =
    useSelector(selectYear) || getDefaultYear(category);
  const month =
    useSelector(selectMonth) ||
    getDefaultMonth(category);
  const day =
    useSelector(selectDay) ||
    getDefaultDay();
  const shipType = useSelector(selectShipType);

  useEffect(() => {
    const layerName =
      category === "forecast"
        ? `Passage_Future_RPC4.5_${year}_${month}`
        : `${shipType}_passage_${year}-${month}-${day}`;
    const passageDate =
      category === "forecast" ? `${year}-${month}` : `${year}-${month}-${day}`;
    promiseDispatch(dispatch, actionCreators.dashboard.panel.query.situation, {
      layerName,
      passageDate,
    }).then((response) => {
      if (response && response.length > 0) {
        const sp = response[0];
        const ep = response[response.length - 1];

        setStartPoint({ lng: sp.lon, lat: sp.lat });
        setEndPoint({ lng: ep.lon, lat: ep.lat });
      }
    });
  }, [dispatch, category, year, month, day, shipType]);

  if (category === "forecast") {
    if (!year || !month) {
      return (
        <div className="indicator-container">
          <div className="body">{t("indicator.layer")}</div>
        </div>
      );
    }
  } else {
    if (!year || !month || !day) {
      return (
        <div className="indicator-container">
          <div className="body">{t("indicator.layer")}</div>
        </div>
      );
    }
  }

  return (
    <div className="indicator-container">
      <Descriptions column={1}>
        <Descriptions.Item label={t("indicator.ds1")}>
          {i18n.language === "zh"
            ? `海冰密集度(${year}-${month}-${day})`
            : `concentration(${day}/${month}/${year})`}
        </Descriptions.Item>
        <Descriptions.Item label={t("indicator.ds2")}>
          {i18n.language === "zh"
            ? `海冰厚度(${year}-${month}-${day})`
            : `thickness(${day}/${month}/${year})`}
        </Descriptions.Item>
        <Descriptions.Item
          label={t("indicator.startPoint")}
        >{`(${startPoint?.lng}, ${startPoint?.lat})`}</Descriptions.Item>
        <Descriptions.Item
          label={t("indicator.endPoint")}
        >{`(${endPoint?.lng}, ${endPoint?.lat})`}</Descriptions.Item>
        <Descriptions.Item label={t("indicator.zone")}>
          {i18n.language === "zh"
            ? "北海、挪威海、巴伦支海、喀拉海、拉普捷夫海、东西伯利亚海、楚科奇海"
            : "North Sea, Norwegian Sea, Barents Sea, Kara Sea, Laptev Sea, East Siberia Sea and Chukchi Sea"}
        </Descriptions.Item>
      </Descriptions>
    </div>
  );
};

export default LayerIndicator;
